module.exports = __webpack_public_path__ + "img/tienda3.1ff74b49.png";